import { useQuery } from "@tanstack/react-query";
import { getCaptainHookVersion } from "../services/captainHookService";

export const useCaptainHookVersion = () =>
  useQuery({
    queryKey: ["captainHookVersion"],
    queryFn: getCaptainHookVersion,
    staleTime: 5 * 60 * 1000,
  });
